"use client";

import { c as _c } from "react/compiler-runtime";
import type React from "react";
import { createContext, useContext } from "react";
import type { FetchResultError } from "@/server/tokenXFetch/FetchResult";
import { useDelPlanMedLegeAction } from "./DelAktivPlan/useDelPlanMedLegeAction";
import { useDelPlanMedVeilederAction } from "./DelAktivPlan/useDelPlanMedVeilederAction";

// This context provider is used to share state between client components that
// are separate children of a root server component. This is a pattern to share
// state between client components without having to make all the common parent
// components also client components. See https://nextjs.org/docs/app/getting-started/server-and-client-components#context-providers.

interface PlanDelingContextValue {
  deltMedLegeTidspunkt: string | null;
  deltMedVeilederTidspunkt: string | null;
  delMedLegeAction: ({
    planId
  }: {
    planId: string;
  }) => void;
  delMedVeilederAction: ({
    planId
  }: {
    planId: string;
  }) => void;
  isPendingDelMedLege: boolean;
  isPendingDelMedVeileder: boolean;
  errorDelMedLege: FetchResultError | null;
  errorDelMedVeileder: FetchResultError | null;
}
const PlanDelingContext = createContext<PlanDelingContextValue | null>(null);
interface ProviderProps {
  initialDeltMedLegeTidspunkt: string | null;
  initialDeltMedVeilederTidspunkt: string | null;
  children: React.ReactNode;
}
export function PlanDelingProvider(t0) {
  const $ = _c(12);
  const {
    initialDeltMedLegeTidspunkt,
    initialDeltMedVeilederTidspunkt,
    children
  } = t0;
  const {
    deltMedLegeTidspunkt,
    delMedLegeAction,
    isPendingDelMedLege,
    errorDelMedLege
  } = useDelPlanMedLegeAction(initialDeltMedLegeTidspunkt);
  const {
    deltMedVeilederTidspunkt,
    delMedVeilederAction,
    isPendingDelMedVeileder,
    errorDelMedVeileder
  } = useDelPlanMedVeilederAction(initialDeltMedVeilederTidspunkt);
  let t1;
  if ($[0] !== delMedLegeAction || $[1] !== delMedVeilederAction || $[2] !== deltMedLegeTidspunkt || $[3] !== deltMedVeilederTidspunkt || $[4] !== errorDelMedLege || $[5] !== errorDelMedVeileder || $[6] !== isPendingDelMedLege || $[7] !== isPendingDelMedVeileder) {
    t1 = {
      deltMedLegeTidspunkt,
      deltMedVeilederTidspunkt,
      delMedLegeAction,
      delMedVeilederAction,
      isPendingDelMedLege,
      isPendingDelMedVeileder,
      errorDelMedLege,
      errorDelMedVeileder
    };
    $[0] = delMedLegeAction;
    $[1] = delMedVeilederAction;
    $[2] = deltMedLegeTidspunkt;
    $[3] = deltMedVeilederTidspunkt;
    $[4] = errorDelMedLege;
    $[5] = errorDelMedVeileder;
    $[6] = isPendingDelMedLege;
    $[7] = isPendingDelMedVeileder;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  const value = t1;
  let t2;
  if ($[9] !== children || $[10] !== value) {
    t2 = <PlanDelingContext value={value}>{children}</PlanDelingContext>;
    $[9] = children;
    $[10] = value;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
}
export function usePlanDelingContext() {
  const ctx = useContext(PlanDelingContext);
  if (!ctx) {
    throw new Error("useDelPlanContext must be used within a DelPlanProvider");
  }
  return ctx;
}